import { useState } from "react";

import { Input } from "@/components/ui/input";
import { formatPhoneInput, formatPhoneDisplay } from "@/lib/phone";

type Props = Omit<React.ComponentProps<typeof Input>, "type" | "onChange" | "value"> & {
  defaultValue?: string | null;
  onChange?: (value: string) => void;
};

/**
 * Phone field that formats as you type. The submitted value is still a plain
 * string; servers normalize it to E.164 before storing.
 */
export function PhoneInput({ defaultValue, onChange, ...props }: Props) {
  const [value, setValue] = useState(() => formatPhoneDisplay(defaultValue ?? ""));

  return (
    <Input
      {...props}
      type="tel"
      inputMode="tel"
      autoComplete="tel"
      placeholder={props.placeholder ?? "(555) 123-4567"}
      maxLength={20}
      value={value}
      onChange={(event) => {
        const next = formatPhoneInput(event.target.value);
        setValue(next);
        onChange?.(next);
      }}
    />
  );
}
